const useUrlIframeBankIds = ["1011", "855"];

const emailRequiredBankIds = ["855", "856"];

export { useUrlIframeBankIds, emailRequiredBankIds };
